<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Header</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.header.title" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Feature Items</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.items" :key="`sowhatbuy-features-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>{{ index + 1 }}. {{ item.tabLabel || item.title || 'Item' }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field v-model="item.tabLabel" label="Tab label" hide-details class="mb-4" />
                <div class="mb-4">
                  <label class="d-block mb-1">Image</label>
                  <UploadImage
                    @callback="obj => handleUploadImage(obj, index)"
                    :image="{ imageSrc: item.image || '' }"
                    :height="`160`"
                    @callbackDelete="() => handleRemoveImage(index)"
                  />
                </div>
                <v-text-field v-model="item.title" label="Card title" hide-details class="mb-4" />
                <v-textarea v-model="item.description" label="Card description" rows="3" hide-details auto-grow />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'sowhatbuy-features-slider-section-editor',
  components: {
    UploadImage,
    ButtonPrimary,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Sowhatbuy features slider',
        enableAnchor: false,
        settings: {},
        containerPage: {},
        header: {
          title: '',
        },
        items: [],
        button: {
          show: true,
          backgroundColor: '#C75023',
          color: '#FFFFFF',
          radius: 8,
          text: 'BUY NOW GET 50% OFF',
          link: '#',
          iconPrefix: {
            show: false,
            src: '',
          },
          iconSuffix: {
            show: true,
            src: 'https://cdn.skyfastimg.com/images/2026/07/02/image-6a45d35b3a84d93f1fcfdd15.png?w=500&h=50&q=80',
          },
          subBtn: {
            show: false,
            text: '',
          },
        },
      },
    };
  },
  watch: {
    sectionEditor: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val?.show && val.sectionExtract) {
          this.applyExtract(val.sectionExtract);
        }
      },
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        header: { ...this.fields.header, ...(extract.header || {}) },
        items: Array.isArray(extract.items) ? extract.items.map(item => ({ ...item })) : [],
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push({
        tabLabel: 'Tab Label',
        image: '',
        title: 'Title',
        description: 'Description',
      });
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
    handleUploadImage(obj, index) {
      if (obj?.imageSrc) {
        this.$set(this.fields.items[index], 'image', obj.imageSrc);
      }
    },
    handleRemoveImage(index) {
      this.$set(this.fields.items[index], 'image', '');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSowhatbuyFeatureSlider(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        html: updateHtml,
        title: this.fields.title,
      });
      this.handleClosePopup();
    },
  },
};
</script>
